import { Col, Input, Text } from 'components';
import { Api, getYtId } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

let timer;
const LinkInput = ({
  metaData,
  youtubeId,
  setMetaData,
  setYoutubeId,
  setLoading,
  loading,
  err
}) => {
  const [value, setValue] = useState(''),
    [error, setError] = useState(''),
    dispatch = useDispatch(),
    { t } = useTranslation();

  useEffect(() => {
    setError(err?.err || '');
  }, [err]);

  async function handleChange(val) {
    clearTimeout(timer);
    setValue(val);

    timer = setTimeout(async () => {
      /*
        No value? Reset everything
      */
      if (!val) {
        setError('');
        setMetaData('');
        setYoutubeId('');

        return;
      }

      setError('');

      /*
        Check if link is actually a URL
      */
      const regexp =
        /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
      const isURL = regexp.test(val);

      if (!isURL) return setError(t('add.correctYoutubeLink'));

      /*
        Guard for initial delete button press while deleting and holding.
        Maybe we can extend this for some edgecases?
      */
      if (value && val.includes(value)) return;
      setLoading(true);

      /*
        Check if URL is YT url or other website URL
      */
      const isYoutube = getYtId(val);

      if (isYoutube) {
        setMetaData(null);
        setYoutubeId(isYoutube);
        // setThumbnail(`https://img.youtube.com/vi/${youtubeId}/0.jpg`)
        setError('');
        return setLoading(false);
      }

      /**
       * @property {string} err
       */
      const fetchedMetaData = await Api.post('/posts/getMetaData', { link: val });

      setLoading(false);

      if (fetchedMetaData.err) {
        dispatch({
          type: 'HANDLE_RES',
          payload: { err: fetchedMetaData.err }
        });

        return;
      }

      if (!fetchedMetaData) {
        return;
      }

      setYoutubeId(null);
      setMetaData(fetchedMetaData);
    }, 300);
  }

  return (
    <Col wid="100%">
      <Text marg="24px 16px 5px" b2 med>
        Share link
      </Text>

      <Input
        placeholder="Enter link..."
        error={error}
        value={value}
        onChange={({ target }) => handleChange(target.value)}
      />
    </Col>
  );
};

export default LinkInput;
